import styled from '@emotion/styled';
import { Modal } from 'antd';
import { Button } from 'components';
import { theme } from 'configs/styled';
import { FormikProps, FormikValues } from 'formik';
import { useQueryParams } from 'hooks/useQueryParams';
import React, { useState } from 'react';
import { authenticationService } from 'services/driverPortal';

const ModalStyle = styled(Modal)`
  .ant-modal-content {
    font-family: ${theme.fonts.NotoSansTh}, ${theme.fonts.NotoSands};
  }
`;

interface IConfirmReturnModal {
  visible?: boolean;
  onCancel?: Function;
  formik?: FormikProps<FormikValues>;
}

const ConfirmLogoutModal: React.FC<IConfirmReturnModal> = props => {
  const { onCancel, formik } = props;
  const [visible, setVisible] = useState(props.visible);
  const { search, pushUrl } = useQueryParams();

  const handleOK = async () => {
    formik?.resetForm({});
    await authenticationService.logout();
    pushUrl('/login', search);
  };

  const handleCancel = () => {
    onCancel && onCancel(false);
    setVisible(false);
  };

  return (
    <ModalStyle
      title="คุณต้องการที่จะออกจากหน้านี้หรือไม่?"
      visible={visible}
      closable={true}
      onOk={handleOK}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          ยกเลิก
        </Button>,
        <Button key="submit" type="primary" onClick={handleOK}>
          ยืนยัน
        </Button>,
      ]}
    >
      ข้อมูลของคุณยังไม่ได้ทำการบันทึกลงฐานข้อมูลของระบบ
      คุณต้องการที่จะออกจากหน้านี้หรือไม่ ?
    </ModalStyle>
  );
};

export default ConfirmLogoutModal;
